import { render } from "./PosReceipt.vue?vue&type=template&id=b4e1dc9e&scoped=true&ts=true"
import script from "./PosReceipt.vue?vue&type=script&lang=ts"
export * from "./PosReceipt.vue?vue&type=script&lang=ts"

import "./PosReceipt.vue?vue&type=style&index=0&id=b4e1dc9e&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e1dc9e"]])

export default __exports__